module.exports = __webpack_public_path__ + "static/eshop-illustration-a655fb16c58565d4bc35f0cc099c82cd.svg";